import { UserRole } from '@hrms/shared/types';

/* ── Departments ── */
export const DEPARTMENTS = [
  'HR',
  'Talent Acquisition',
  'Digital Marketing',
  'Sales',
  'Finance',
  'Operations',
  'Development',
  'QA',
  'Design',
  'BA',
  'Devops',
];

/* ── Roles ── */
export const USER_ROLES = [
  { value: UserRole.EMPLOYEE, label: 'Employee' },
  { value: UserRole.ADMIN, label: 'Admin' },
  { value: UserRole.SUPER_ADMIN, label: 'Super Admin' },
  { value: UserRole.CEO, label: 'CEO' },
  { value: UserRole.CFO, label: 'CFO' },
  { value: UserRole.DIRECTOR, label: 'Director' },
  { value: UserRole.COO, label: 'COO' },
  { value: UserRole.CTO, label: 'CTO' },
];

/* ── ProfilePage ── */
export const PROFILE_PAGE_TEXT = {
  bannerTitle: 'My Profile',
  backToDashboard: 'Back to Dashboard',
  userNotFound: 'User not found. Please log in again.',
  superAdminLabel: 'Super Admin',
  tabsAriaLabel: 'profile tabs',
  editProfileTab: 'Edit Profile',
  changePasswordTab: 'Change Password',
} as const;

/* ── EditProfileForm ── */
export const EDIT_PROFILE_TEXT = {
  cardTitle: 'Edit Profile',
  firstNameLabel: 'First Name',
  lastNameLabel: 'Last Name',
  phoneLabel: 'Phone',
  phonePlaceholder: '10-digit mobile number',
  countryFlag: '🇮🇳',
  countryCode: '+91',
  departmentLabel: 'Department',
  designationLabel: 'Designation',
  dateOfJoiningLabel: 'Date of Joining',
  updatingButton: 'Updating...',
  updateButton: 'Update Profile',
  updateSuccessToast: 'Profile updated successfully',
  updateFailToast: 'Failed to update profile',
} as const;

export const EDIT_PROFILE_ERRORS = {
  firstNameRequired: 'First name is required',
  lastNameRequired: 'Last name is required',
  phoneInvalid: 'Please enter a valid phone number',
} as const;

/* ── ChangePasswordForm ── */
export const CHANGE_PASSWORD_TEXT = {
  cardTitle: 'Change Password',
  currentPasswordLabel: 'Current Password',
  newPasswordLabel: 'New Password',
  confirmPasswordLabel: 'Confirm New Password',
  newPasswordHelperText:
    'Password must contain at least 8 characters with uppercase, lowercase, number and special character',
  changingButton: 'Changing Password...',
  changeButton: 'Change Password',
  changeSuccessToast: 'Password changed successfully',
  changeFailToast: 'Failed to change password',
} as const;

export const CHANGE_PASSWORD_ERRORS = {
  currentPasswordRequired: 'Current password is required',
  newPasswordRequired: 'New password is required',
  newPasswordTooShort: 'Password must be at least 8 characters long',
  newPasswordComplexity:
    'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
  confirmPasswordRequired: 'Password confirmation is required',
  passwordsDoNotMatch: 'Passwords do not match',
  newPasswordSameAsCurrent: 'New password must be different from current password',
} as const;

/* ── UserManagementPage ── */
export const USER_MANAGEMENT_TEXT = {
  clearButton: 'Clear',
} as const;

/* ── Managers Info Text ── */
export const MANAGERS_INFO_TEXT = {
  reportingTo: 'Reporting to',
  dottedLineReporting: 'with dotted-line reporting to',
  hrIs: 'and HR is',
  noneAssigned: 'No managers assigned',
} as const;

/* ── User Details Page ── */
export const USER_DETAILS_TEXT = {
  // Tabs
  tabOverview: 'Overview',
  tabPersonal: 'Personal Details',
  tabEmployment: 'Employment & Education',
  tabRemarks: 'Remarks',

  // Sections
  sectionPersonal: 'Personal Details',
  sectionContact: 'Contact Details',
  sectionJob: 'Job Details',
  sectionAddresses: 'Addresses',
  sectionEmergency: 'Emergency Contact',
  sectionHRRemarks: 'HR Remarks',
  sectionEmployment: 'Employment & Education',

  // Fields
  fieldFullName: 'Full Name',
  fieldEmployeeId: 'Employee ID',
  fieldEmail: 'Email',
  fieldPhoneNumber: 'Phone Number',
  fieldOfficialEmail: 'Official Email ID',
  fieldAltNumber: 'Alt. Number',
  
  fieldReportingManager: 'Reporting Manager',
  fieldHR: 'HR',
  fieldDateOfJoining: 'Date of Joining',
  fieldCreatedAt: 'Created At',

  fieldPresentAddress: 'Present Address',
  fieldPermanentAddress: 'Permanent Address',

  fieldEmergencyName: 'Emergency Contact Name',
  fieldEmergencyRelationship: 'Emergency Contact Relationship',
  fieldEmergencyNumber: 'Emergency Contact Number',

  fieldDOB: 'DOB',
  fieldBloodGroup: 'Blood Group',
  fieldAadhar: 'Aadhar',
  fieldPAN: 'PAN',

  fieldLocation: 'Location',
  fieldDepartment: 'Department',
  fieldDesignation: 'Designation',
  fieldDottedLineManagers: 'Dotted-Line Managers',
  fieldPastEmployer: 'Past employer',
  fieldDOE: 'Date of Exit',
  fieldQualification: 'Qualification & Passed Year',

  fieldRemarks: 'Remarks',
  fieldLastLogin: 'Last Login',
} as const;

/* ── Emergency Contacts ── */
export const EMERGENCY_RELATIONSHIPS = [
  'Mother',
  'Father',
  'Sibling',
  'Guardian',
  'Friend'
] as const;

